module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.5881/images/default-avatar.png"